'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOpenThreads = undefined;

var _reselect = require('reselect');

var _filter = require('transmute/filter');

var _filter2 = _interopRequireDefault(_filter);

var _isStarted = require('conversations-schema/thread/operators/isStarted');

var _getThreadList = require('./getThreadList');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOpenThreads = exports.getOpenThreads = (0, _reselect.createSelector)([_getThreadList.getThreadList], (0, _filter2.default)(_isStarted.isStarted));